export const COLLECTIONS = {
  student: "student",
  teacher: "teacher",
  studentGroup: "studentGroup",
  teacherGroup: "teacherGroup",
} as const;
